import { rest } from 'msw';
import { API_ROOT } from 'configs/env-vars';
import { mobilePhoneData } from '__mocks__/mockData/user-settings-data';

const UserSettingsApi = [
  rest.post(`${API_ROOT}user-settings`, (req, res, ctx) => {
    const { mobilePhone, verificationCode } = req.body;

    if (mobilePhone?.length === 12 || verificationCode?.length === 6) {
      return res(ctx.json(mobilePhoneData));
    }
    return res(
      ctx.status(400),
      ctx.json({
        className: 'bad-request',
        code: 400,
        errors: {},
        message: 'Your mobile phone number +1 is not valid',
        name: 'BadRequest',
      }),
    );
  }),
];

export default UserSettingsApi;
